import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import GameInterface from './index';
import store from '../../state/store';
import { setNewAgsiBet, setFeatureModeEnabled } from '../../state/actions/agsi';
import { setSpinEvent } from '../../state/slices/spinEvent/spinEvent';
import SPIN_PHASE from './helpers/spinPhases';
var POPUP_RELOAD_WINDOW_MS = 2000;
var SESSION_INVALIDATION_LOAD_TIMEOUT_MS = 3000;
var STALLED_LOAD_PROGRESS_UPDATES_THRESHOLD = 10;
var Agsi = /*#__PURE__*/function (_GameInterface) {
  /**
   * GameInterface constructor
   * @param {Object} args
   * @param {import("../Constants").BetInfo} args.BetInfo
   * @param {Function} args.ExitFunc
   */
  function Agsi(args) {
    var _this;
    _classCallCheck(this, Agsi);
    _this = _callSuper(this, Agsi, [args]);
    /**
     * Agsi Event Handler
     * @param {import("./helpers/parseEvent").ParsedEvent} event
     */
    _this.kvpParserEvent = function () {};
    _this.dispose = function () {
      _this.resetPopupReloadTracking({
        clearPopup: true
      });
    };
    _this.resetPopupReloadTracking = function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$clearPopup = _ref.clearPopup,
        clearPopup = _ref$clearPopup === void 0 ? false : _ref$clearPopup;
      clearTimeout(_this.popupReloadTimer);
      clearTimeout(_this.sessionInvalidationTimer);
      _this.popupReloadTimer = null;
      _this.sessionInvalidationTimer = null;
      _this.popupReloadStage = null;
      _this.stalledLoadProgressUpdates = 0;
      if (clearPopup) {
        _this.activePopupKind = null;
      }
    };
    _this.triggerSessionInvalidated = function (reason) {
      _this.resetPopupReloadTracking();
      _this.sessionInvalidated(reason);
    };
    _this.trackPopupReloadState = function (action) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      switch (action) {
        case 'gamePopupShown':
          _this.resetPopupReloadTracking();
          _this.activePopupKind = 'generic';
          return;
        case 'insufficientFunds':
          _this.activePopupKind = 'outOfCoins';
          _this.resetPopupReloadTracking();
          return;
        case 'gamePopupHidden':
          // AGS does not expose the popup reason here, so only treat it as a
          // session-expiration candidate if it leads to a stalled reload and we
          // did not receive the explicit insufficient-funds event.
          if (_this.activePopupKind !== 'generic') {
            _this.activePopupKind = null;
            _this.resetPopupReloadTracking();
            return;
          }
          _this.activePopupKind = null;
          _this.resetPopupReloadTracking();
          _this.popupReloadStage = 'awaitingReloadStart';
          _this.popupReloadTimer = setTimeout(function () {
            if (_this.popupReloadStage !== 'awaitingReloadStart') return;
            _this.popupReloadStage = null;
            _this.popupReloadTimer = null;
          }, POPUP_RELOAD_WINDOW_MS);
          return;
        case 'gameLoadingStarted':
          if (_this.popupReloadStage !== 'awaitingReloadStart') return;
          clearTimeout(_this.popupReloadTimer);
          _this.popupReloadTimer = null;
          _this.popupReloadStage = 'awaitingProgress';
          _this.stalledLoadProgressUpdates = 0;
          _this.sessionInvalidationTimer = setTimeout(function () {
            if (_this.popupReloadStage !== 'awaitingProgress') return;
            _this.triggerSessionInvalidated('reloadTimeout');
          }, SESSION_INVALIDATION_LOAD_TIMEOUT_MS);
          return;
        case 'loadProgressUpdate':
          if (_this.popupReloadStage !== 'awaitingProgress') return;
          if (Number((data === null || data === void 0 ? void 0 : data.percent) || 0) > 0) {
            _this.resetPopupReloadTracking();
            return;
          }
          _this.stalledLoadProgressUpdates += 1;
          if (_this.stalledLoadProgressUpdates >= STALLED_LOAD_PROGRESS_UPDATES_THRESHOLD) {
            _this.triggerSessionInvalidated('stalledLoadProgress');
          }
          return;
        case 'gameLoadingEnded':
          _this.resetPopupReloadTracking();
          return;
        default:
          return;
      }
    };
    /**
     * Check FTUE Event Handler
     * @param {import("./helpers/parseEvent").ParsedEvent} event
     */
    _this.jsonParserEvent = function (event) {
      var playerId = store.getState().playerInfo.playerId;
      var gameId = store.getState().gameInfo.gameId;
      var _store$getState$lastS = store.getState().lastSpinEvents.balanceAfter,
        balance = _store$getState$lastS === void 0 ? null : _store$getState$lastS;
      var featureModeEnabled = store.getState().agsi.featureModeEnabled;
      _this.trackPopupReloadState(event.action, event.data);
      switch (event.action) {
        case 'stakeUpdate':
          store.dispatch(setNewAgsiBet(event.data.stake / 100));
          break;
        case 'gameRoundStarted':
          /*
            Agsi does not offer a specific event for free spins
            so we use the 'featureModeEnabled' flag to know if the player is
            inside free spins/jackpots/bonuses or real spins
          */
          if (!featureModeEnabled) {
            _this.currentBet = store.getState().agsi.betValue;
            store.dispatch(setSpinEvent({
              playerId: playerId,
              createdTimestamp: Date.now(),
              spinPhase: SPIN_PHASE.WAGE,
              amount: _this.currentBet,
              defaultBet: _this._defaultBet,
              gameId: gameId
            }));
          }
          break;
        case 'insufficientFunds':
          _this._outOfCoins();
          _this.showOutOfCoinsScreen();
          break;
        case 'enableFeatureMode':
          store.dispatch(setFeatureModeEnabled(true));
          break;
        case 'disableFeatureMode':
          store.dispatch(setFeatureModeEnabled(false));
          break;
        case 'winningsUpdate':
          if (event.data.winnings > 0 && !featureModeEnabled) store.dispatch(setSpinEvent({
            playerId: playerId,
            createdTimestamp: Date.now(),
            spinPhase: SPIN_PHASE.WIN,
            gameId: gameId,
            amount: event.data.winnings,
            defaultBet: _this._defaultBet
          }));
          break;
        case 'gameRoundEnded':
          if (!featureModeEnabled) {
            _this.AddSpinXP(_this.currentBet);
          }
          break;
        case 'balancesUpdate':
          if (!featureModeEnabled) {
            _this.syncCoinsBalance(event.data.balances.cash);
            store.dispatch(setSpinEvent({
              balanceBefore: balance ? balance : event.data.balances.cash,
              balanceAfter: event.data.balances.cash,
              defaultBet: _this._defaultBet
            }));
          }
          break;
      }
    };
    _this.currentBet = 0;
    _this.activePopupKind = null;
    _this.popupReloadStage = null;
    _this.stalledLoadProgressUpdates = 0;
    _this.popupReloadTimer = null;
    _this.sessionInvalidationTimer = null;
    _this.sessionInvalidated = args.SessionInvalidated || function () {};
    return _this;
  }
  _inherits(Agsi, _GameInterface);
  return _createClass(Agsi);
}(GameInterface);
export default Agsi;